module.exports = __webpack_public_path__ + "static/media/worldscitech.57ce9787.jpg";